import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';

/**
 * Legacy route: Instagram Basic Display OAuth was removed (Phase 2.4).
 * Instagram API posting uses Facebook Login + a Page linked to Instagram Business.
 */
export default function InstagramOAuthCallback() {
  useEffect(() => {
    const msg =
      'Instagram OAuth here is no longer used. On Clients, connect Facebook, assign a Page, Link Instagram for dual-publish, then post to Facebook.';
    if (window.opener) {
      window.opener.postMessage(
        { type: 'instagram_error', error: msg },
        window.location.origin,
      );
    }
  }, []);

  return (
    <Box
      sx={{
        p: 4,
        minHeight: '100vh',
        bgcolor: '#0d1117',
        color: '#f0f6fc',
        maxWidth: 520,
        mx: 'auto',
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Instagram connect moved
      </Typography>
      <Typography variant="body2" sx={{ color: '#8b949e', mb: 3 }}>
        This app no longer uses a separate Instagram login screen. On{' '}
        <strong>Clients</strong>, connect <strong>Facebook</strong>, assign a{' '}
        <strong>Facebook Page</strong>, then use <strong>Link Instagram</strong>{' '}
        so feed posts dual-publish with Facebook.
      </Typography>
      <Button variant="contained" href="/clients" sx={{ mr: 1 }}>
        Go to Clients
      </Button>
      <Button variant="outlined" href="/" sx={{ color: '#f0f6fc', borderColor: '#30363d' }}>
        Dashboard
      </Button>
    </Box>
  );
}
